<template>
  <van-icon name="cross" class="closePageButton" @click="$router.back()" />
</template>

<script>
export default {};
</script>

<style>
.closePageButton {
  position: absolute;
  top: 14px;
  right: 18px;
  text-align: center;
  font-size: 13px;
  color: #c8c9cc;
  border: 2px solid#c8c9cc;
  border-radius: 50%;
  box-sizing: border-box;
}
</style>